module.exports = __webpack_public_path__ + "img/upload-card.94d49cf9.png";